import { ComponentType as o } from "../../registries/types/propTypes.js";
const i = (n) => {
  const t = Array.isArray(n.rich_text_component) ? n.rich_text_component[0] : n.rich_text_component;
  return {
    componentType: o.rich_text_component,
    title: t.display_title,
    content: t.content,
    sanitize: t.sanitize ?? !1,
    sanitizationConfig: t.sanitizationConfig ?? {}
  };
};
export {
  i as default
};
//# sourceMappingURL=richTextComponentTransformer.js.map
